// data-tooltip-copy attribute is needed

class CopyTextToClipboard extends HTMLElement {
  constructor() {
    super();
  }

  copyContentToClipboard = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch (err) {
      console.error("Failed to copy: ", err);
      return false;
    }
  };

  async handleCopyClick() {
    const textToCopy = this.textContent.trim();
    const copyResponse = await this.copyContentToClipboard(textToCopy);
    if (copyResponse == false) return;
    this.classList.add("tooltip-active");
    setTimeout(() => {
      this.classList.remove("tooltip-active");
    }, 3000);
  }

  connectedCallback() {
    this.addEventListener("click", this.handleCopyClick);
  }

  disconnectedCallback() {
    this.removeEventListener("click", this.handleCopyClick);
  }
}

if (!customElements.get("copy-text-to-clipboard")) {
  customElements.define("copy-text-to-clipboard", CopyTextToClipboard);
}
